<template>
    <v-row
      justify="center"
      :class="cardsRowClass"
    >
      <v-col
        v-for="(item, index) in ITEMS_COMPUTED"
        :key="index"
        class="d-flex align-center justify-center"
      >
        <v-card
          class="square-card mt-3 mb-3 mx-3 border-card"
          @click="rotaSelecionada(item.link)"
        >
          <v-icon
            size="120"
            color="blue"
            :class="getFlippedClass(item.icon)"
          >
            {{ item.icon }}
          </v-icon>
          <div
            class="text-card"
          >
            {{ item.descricao }}
          </div>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { buscarModulosConfiguracaoMenuParametrizacao } from "./Menu/Api";

export default {
  name: 'Parametrizacao',
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaInicial", this.$route.path);
    this.buscarModulos();
  },
  methods: {
    getFlippedClass(icon) {
      return icon === 'mdi-account-settings' ? 'flip-icon' : '';
    },
    rotaSelecionada(rota) {
      const url = this.$route.path + rota;
      this.$router.push(url);
    },
    buscarModulos() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarModulosConfiguracaoMenuParametrizacao()
          .then((modulos) => this.items = modulos)
          .catch(() => this.Helpers.logout())
      )
    },
  },
  computed: {
    cardsRowClass() {
      return 'd-flex justify-center full-height';
    },
    ITEMS_COMPUTED() {
      return this.items.filter(i => i.link);
    }
  },
};
</script>

<style scoped>
.full-height {
  max-height: 100%;
}
.v-card__text {
  text-align: center;
}

.square-card {
  padding: 60px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.border-card {
  border: 1px solid #ccc;
  border-radius: 20px;
}

.text-card {
  font-size: 1.5em;
  margin-top: 10px;
  text-align: center;
}

.flip-icon {
  transform: scaleX(-1);
}
</style>
